// extracted by mini-css-extract-plugin
export default {"description":"sLutpr","form":"mtXRqO","codeInput":"PymJmK"};